import { ref } from 'vue'

export const DATA_TYPE = {
  ORDER: 'order',
  CUSTOMER: 'customer',
  MERCHANDISE_STATISTICS: 'merchandiseStatistics',
  COUPON: 'coupon',
  PROFIT_SHARING: 'profitSharing',
  VERIFICATION_RECORD: 'verificationRecord',
  INTEGRAL: 'integral',
}

export const CONFIG = {
  [DATA_TYPE.CUSTOMER]: {
    label: '客户',
    mineTip: `该列表用于查看当前归属于你名下的客户（包含下级代理名下的客户）`,
    storeTip: `该列表用于查看相同门店的代理下的客户`,
  },
  [DATA_TYPE.ORDER]: {
    label: '订单',
    mineTip: `该列表用于查看订单中记录的代理层级中包含自己的所有订单`,
    storeTip: `该列表支持查看订单中记录的门店为当前所选择的门店的订单`,
  },
  [DATA_TYPE.MERCHANDISE_STATISTICS]: {
    label: '商品统计',
    mineTip: `该列表用于查看订单中记录的代理层级中包含自己的所有订单的统计数据`,
    storeTip: `该列表用于查看订单中记录的门店为当前所选择门店的订单的统计数据`,
  },
  [DATA_TYPE.COUPON]: {
    label: '优惠券',
    mineTip: `该列表用于查看当前归属于你名下的客户的优惠券领取和使用情况（包含下级代理名下的客户）`,
    storeTip: `该列表用于查看相同门店的代理下的客户的优惠券领取和使用情况`,
  },
  [DATA_TYPE.PROFIT_SHARING]: {
    label: '分佣',
    mineTip: `该列表用于查看自己的分佣明细（不包含下级代理的分佣明细）`,
    storeTip: `该列表用于查看相同门店下的其他代理的分佣明细`,
  },
  [DATA_TYPE.VERIFICATION_RECORD]: {
    label: '核销记录',
    mineTip: `该列表用于查看自己所有核销记录（包含下级代理的全部核销记录）`,
    storeTip: `该列表支持查看相同门店下的其他代理的核销记录`,
  },
  [DATA_TYPE.INTEGRAL]: {
    label: '客户积分',
    mineTip: `该列表用于查看发放时/兑换时记录的代理层级中包含你的记录`,
    storeTip: `该列表用于查看发放时/兑换时记录的门店与你所选择查看的门店相同的记录`,
  },
}

/**
 * 生成 tab 数据
 *
 * @param {DATA_TYPE} dataType 数据类型
 * @returns {Array} 最终渲染 tabs dto
 */
export const generateTabs = dataType => {
  return [
    {
      label: `我的${CONFIG[dataType].label}`,
      value: 'mine',
      tip: CONFIG[dataType].mineTip,
      tipPlacement: 'bottom',
    },
    {
      label: `门店${CONFIG[dataType].label}`,
      value: 'store',
      tip: CONFIG[dataType].storeTip,
      tipPlacement: 'bottom-end',
    },
  ]
}
